import { Box, Flex, MediaBox, Typography, Image } from "@jewlr/storybook/core"
import styled from "styled-components"

import { Text } from "@jewlr/storybook/info"

const ReviewTitle = styled(Typography).attrs((props) => ({
  as: "h3",
  fontSize: { _: 18, tablet: 22 },
  fontWeight: "normal",
  lineHeight: 1,
  ...props,
}))``

const Rating = styled(Flex).attrs((props) => ({
  gutter: 2,
  justifyContent: "center",
  mb: 2,
  ...props,
}))``

const RatingLabel = styled(Box).attrs((props) => ({
  color: "neutral",
  fontSize: 14,
  fontWeight: 300,
  width: "68px",
  ...props,
}))``

const ratingData = [
  {
    percentage: "78%",
    star: 5,
  },
  {
    percentage: "16%",
    star: 4,
  },
  {
    percentage: "4%",
    star: 3,
  },
  {
    percentage: "1%",
    star: 2,
  },
  {
    percentage: "1%",
    star: 1,
  },
]

const ReviewsChart = () => {
  return (
    <Flex flexWrap="wrap" gutter={{ tablet: 3 }} mb={5}>
      <Box
        flexBasis={{ _: "100%", tablet: "50%" }}
        mb={{ _: 5, tablet: 0 }}
        px={2}
      >
        <Box
          bg="grey.4"
          height="100%"
          p={{ _: 4, tablet: "56px 40px" }}
          textAlign={{ _: "center", tablet: "left" }}
        >
          <ReviewTitle mb={{ _: 3, tablet: 4 }}>
            Hear what our customers
            <span className="nowrap"> are saying.</span>
          </ReviewTitle>
          <Image
            alt="Star Reviews"
            height="19px"
            mb={2}
            src={require("images/info/reviews/50k-stars.png")}
            width="116px"
          />
          <Text>50K+ 5-Star Reviews</Text>
        </Box>
      </Box>
      <Box flexBasis={{ _: "100%", tablet: "50%" }}>
        <Box mb={3} textAlign="center">
          <ReviewTitle>94% of Reviews</ReviewTitle>
          <Text>are 4 and 5-star-rating</Text>
        </Box>
        {ratingData.map((rate, i) => (
          <Rating key={`reviewbar${i}`}>
            <RatingLabel>{rate.star} star</RatingLabel>
            <Box flex="1">
              <Box bg="grey.4" width="100%">
                <Box bg="#FAD474" height="20px" width={rate.percentage} />
              </Box>
            </Box>
            <RatingLabel>{rate.percentage}</RatingLabel>
          </Rating>
        ))}

        <Rating>
          <MediaBox greaterThanOrEqual="tablet">
            <RatingLabel />
          </MediaBox>
          <Box flex="1">
            <RatingLabel fontSize="10px" width="auto">
              From Shopper Approved
            </RatingLabel>
          </Box>
        </Rating>
      </Box>
    </Flex>
  )
}

ReviewsChart.propTypes = {}

export default ReviewsChart
